import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/**
 * require.context接收3个参数
 * 第一个参数是目录名称，会读取该目录下为文件
 * 第二个参数，是否读取子目录，如果为true，会继续读取子目录下的文件
 * 第三个参数，正则表达式，满足正则的文件名才会被读取
 */
const moduleContext = require.context('./modules', false, /\.js$/);

const moduleKeys = moduleContext.keys();

const routeModules = moduleKeys.reduce((acc, item) => {
  const moduleItem = moduleContext(item).default;
  acc = [...acc, ...moduleItem];
  return acc;
}, []);

export default new Router({
  routes: routeModules
});
